var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var menu = ref.on;
var attrs = ref.attrs;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"right":_vm.right,"left":_vm.left,"small":_vm.small}},'v-icon',attrs,false),Object.assign({}, tooltip, menu)),[_vm._v(_vm._s(_vm.icon)+" ")])]}}],null,true)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }